import React, { useContext, useState } from "react"
import { Grid, Box, Button, DialogTitle, Snackbar, Alert, Stack } from "@mui/material"
import __t from "../../../lib/traduzioni"
import BSSDataContext from "../../../contexts/BSSDataContext"
import BSSDrawer from "../../form/BSSDrawer"
import {_Rubrica} from "../../account/Rubrica"
import { IconButton, Typography } from "@mui/material"
import { Cancel, Close } from "@mui/icons-material"
import BSSSnackbar from "../../form/BSSSnackbar"

const FrammentoSelettoreRubrica = ({methods, classes}) => {
    
    const {rubrica = []} = useContext(BSSDataContext);
    const [mostraRubrica, setMostraRubrica] = useState(false)
    const [indirizzoApplicato, setIndirizzoApplicato] = useState(false)

    return (
        <>
            <Grid item  xs={12} className={classes.formGroupBox} >                 
                <Button onClick={e => setMostraRubrica(true)} variant="contained" fullWidth color={"primary"}>
                    {__t("consultarubrica")}
                </Button>         
            </Grid>

            <BSSDrawer open={mostraRubrica} onClose={e => setMostraRubrica(false)} sx={{
                '& .MuiDrawer-paper': {
                    width: [1, 1/2],
                },
            }} >
                <DialogTitle >
                    <Box display="flex">
                        <Box p={2} flexGrow={1}>
                            <h3>{__t("rubrica")}</h3>
                        </Box>
                        <Box>
                            <Button onClick={e => setMostraRubrica(false)}><Cancel color="secondary" /></Button>                            
                        </Box>
                    </Box>                    
                </DialogTitle>

                <_Rubrica cardWrapper={false} inPreventivo={{methods, setMostraRubrica, indirizzoApplicato, setIndirizzoApplicato}} />                   

                <BSSSnackbar key={indirizzoApplicato.contesto} open={indirizzoApplicato !== false} onClose={e => setIndirizzoApplicato(false)} >                    
                    <Alert severity={"success"}  action={
                        <>
                            
                            <Button                            
                                onClick={() => {
                                    setMostraRubrica(false)
                                    setIndirizzoApplicato(false)
                                }}
                            >
                                {__t("tornapreventivo")}
                            </Button>

                            <Button                            
                                onClick={() => {
                                    setIndirizzoApplicato(false)
                                }}
                            >
                                <Close fontSize="inherit" />
                            </Button>
                        </>
                    } >
                        {indirizzoApplicato !== false && (
                            <Typography>
                                <Stack>
                                    <Box>
                                        <b>{__t("applicatocome")} {__t(indirizzoApplicato.contesto)} :</b>
                                    </Box>
                                    <Stack>                                                        
                                        <Box>                                                                                                            
                                            {" "}{indirizzoApplicato.labelParts.indirizzoLabel}, {indirizzoApplicato.labelParts.localitaLabel}                                                                
                                        </Box>
                                        <Box>{indirizzoApplicato.labelParts.contattareLabel}</Box>
                                    </Stack>
                                </Stack>                                
                            </Typography>
                        )}
                        
                        
                    </Alert> 
                </BSSSnackbar> 
            </BSSDrawer> 
        </>
    )
}

export default FrammentoSelettoreRubrica